import React, { useContext, useEffect } from 'react'
import { Container } from 'reactstrap'
import Table from './components/Datatable'
import { withRouter } from 'react-router-dom'
import { GeneralContext } from '../../context/'

const Index = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setBreadcrumb } = generalContext

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Configuraciones`,
            parentLink: '/settings',
            item: `Lista de usuarios`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <React.Fragment>
            <div id="mainContent" className="page mainContent">
                <Container fluid>
                    <Table />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Index)